import PostNewQuestion from 'components/PostNewQuestion';
import Modal from 'shared/Modal';

export default function PostQuestion({
  visible,
  toggle,
}: {
  visible: boolean;
  toggle: () => void;
}) {
  return (
    <Modal visible={visible} toggle={toggle}>
      <PostNewQuestion handleClose={toggle}/>
    </Modal>
  );
}
